export function selectSystemMaintenanceMessage(state) {
  return state.systemMaintenanceMessage;
}
